import React, { useMemo, memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ChinaFlag from '../../assets/flagsETF/China.svg';
import USlag from '../../assets/flagsETF/US.svg';
import JPFlag from '../../assets/flagsETF/JP.svg';
import EUFlag from '../../assets/flagsETF/EU.svg';
import OilFlag from '../../assets/flagsETF/Oil.svg';
import GoldFlag from '../../assets/flagsETF/Gold.svg';
import WORLDFlag from '../../assets/flagsETF/World.svg';
import InvastFlag from '../../assets/flagsETF/invast-circle.svg';
import Gold2Flag from '../../assets/flagsETF/Gold_2.svg';
import SilverFlag from '../../assets/flagsETF/Silver.svg';
import TOPIX from '../../assets/flagsETF/1306.svg';
import NIKKEI225 from '../../assets/flagsETF/1321.svg';
import TSE1357 from '../../assets/flagsETF/1357.svg';
import TSE1570 from '../../assets/flagsETF/1570.svg';
import ACWI from '../../assets/flagsETF/ACWI.svg';
import FAS from '../../assets/flagsETF/FAS.svg';
import HYG from '../../assets/flagsETF/HYG.svg';
import IWD from '../../assets/flagsETF/IWD.svg';
import IWM from '../../assets/flagsETF/IWM.svg';
import LQD from '../../assets/flagsETF/LQD.svg';
import QQQ from '../../assets/flagsETF/QQQ.svg';
import SPY from '../../assets/flagsETF/SPY.svg';
import SSO from '../../assets/flagsETF/SSO.svg';
import TQQQ from '../../assets/flagsETF/TQQQ.svg';
import VWO from '../../assets/flagsETF/VWO.svg';
import XLE from '../../assets/flagsETF/XLE.svg';
import XLF from '../../assets/flagsETF/XLF.svg';
import XLI from '../../assets/flagsETF/XLI.svg';
import ARKK from '../../assets/flagsETF/ARKK.svg';
import VXX from '../../assets/flagsETF/VXX.svg';
import XLY from '../../assets/flagsETF/XLY.svg';
import XLK from '../../assets/flagsETF/XLK.svg';
import XLP from '../../assets/flagsETF/XLP.svg';
import XLU from '../../assets/flagsETF/XLU.svg';
import TMF from '../../assets/flagsETF/TMF.svg';
import TMV from '../../assets/flagsETF/TMV.svg';
import SOXL from '../../assets/flagsETF/SOXL.svg';
import UGL from '../../assets/flagsETF/UGL.svg';
import AGQ from '../../assets/flagsETF/AGQ.svg';
import DJIA from '../../assets/flagsETF/DJIA.svg';
import JEPQ from '../../assets/flagsETF/JEPQ.svg';
import CHPY from '../../assets/flagsETF/CHPY.svg';
import GDXY from '../../assets/flagsETF/GDXY.svg';
import SMH from '../../assets/flagsETF/SMH.svg';
import QTUM from '../../assets/flagsETF/QTUM.svg';
import ITA from '../../assets/flagsETF/ITA.svg';
import GDX from '../../assets/flagsETF/GDX.svg';

import styles from './customFlagETF.module.scss';

const ETF_FLAG_TYPE = {
  China: ChinaFlag,
  US: USlag,
  JP: JPFlag,
  EU: EUFlag,
  Oil: OilFlag,
  Gold: GoldFlag,
  World: WORLDFlag,
  Invast: InvastFlag,
  Gold_2: Gold2Flag,
  Silver: SilverFlag,
  1306: TOPIX,
  1321: NIKKEI225,
  1357: TSE1357,
  1570: TSE1570,
  ACWI,
  FAS,
  HYG,
  IWD,
  IWM,
  LQD,
  QQQ,
  SPY,
  SSO,
  TQQQ,
  VWO,
  XLE,
  XLF,
  XLI,
  ARKK,
  VXX,
  XLY,
  XLP,
  XLU,
  XLK,
  TMF,
  TMV,
  SOXL,
  UGL,
  AGQ,
  DJIA,
  JEPQ,
  CHPY,
  GDXY,
  SMH,
  QTUM,
  ITA,
  GDX,
};

const CustomFlagETF = ({ flagType, className, size }) => {
  const currencyFlagType = flagType.split('.')[0];
  const src = useMemo(() => ETF_FLAG_TYPE[currencyFlagType], [currencyFlagType]);
  const sizeStyle = size ? { width: size, height: size } : undefined;
  if (!src) return null;
  return (
    <img src={src} style={sizeStyle} className={classNames(styles.flagImage, { [className]: className })} alt="" />
  );
};

CustomFlagETF.propTypes = {
  flagType: PropTypes.string.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

CustomFlagETF.defaultProps = {
  className: '',
  size: undefined,
};

export default memo(CustomFlagETF);
